import SectionHead from "./SectionHead";
import { Reveal } from "./Reveal";

const Services = ({ t }) => (
  <section className="section" id="services" data-testid="services-section">
    <div className="wrap">
      <SectionHead eyebrow={t.servicesLabel} title={t.servicesTitle} intro={t.servicesIntro} />
      <div className="grid services-grid">
        {t.services.map((s, i) => (
          <Reveal key={i} delay={(i % 2) * 0.1} className="service-card" data-testid={`service-card-${i + 1}`}>
            <span className="mono num">{`0${i + 1}`}</span>
            <h3>{s.title}</h3>
            {s.sub && <p className="svc-sub serif-i">{s.sub}</p>}
            <p className="svc-desc">{s.desc}</p>
            {s.linkTo && (
              <a className="textlink svc-link" href={s.linkTo} data-testid={`service-link-${i + 1}`}>
                {s.linkLabel} <span className="arr-down">↓</span>
              </a>
            )}
          </Reveal>
        ))}
      </div>
      <div className="services-limpieza">
        <a className="textlink services-limpieza-link" href="/limpieza" data-testid="services-limpieza-link">
          ¿Tienes una empresa de limpieza? Mira lo que hago para ti <span className="arr">→</span>
        </a>
      </div>
    </div>
  </section>
);

export default Services;
